import React from "react";
import { data } from "./data";

const Why = () => {
  return (
    <div className="flex flex-col items-center w-full pb-10 pt-4 text-white bg-why">
      <div className="h-auto relative max-w-screen-xl flex flex-col items-center w-full py-6 sm:py-10 gap-10 px-5 xl:px-0">
        <p className="text-5xl sm:text-8xl">Why Choose Us</p>
        <div className="flex w-full h-full relative z-10 justify-center items-center gap-6 flex-wrap">
          {data.map((item, index) => (
            <div
              className="why-card flex flex-col gap-4 justify-center items-center w-[46%] sm:w-[31%] h-[200px] shadow-lg group overflow-hidden cursor-pointer"
              key={index}
            >
              <img
                src={item.image}
                alt={item.id}
                className="w-[72px] h-auto group-hover:scale-105 group-hover:origin-center transition-all"
              />
              <p className="max-w-[80%] lg:text-xl md:text-lg sm:text-md text-white-6 w-full sm:h-[60px] h-[40px] flex items-center text-center justify-center group-hover:scale-110 group-hover:origin-center transition-all ">
                {item.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Why;
